var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2564 0C4.59195 0 0 4.47715 0 10C0 15.5228 4.59195 20 10.2564 20C15.9209 20 20.5128 15.5228 20.5128 10C20.5062 4.47982 15.9181 0.00642897 10.2564 0Z",
    fill: "#FFF0B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1767 6.83362L10.3263 14.5745C10.1867 14.7549 9.97868 14.8732 9.74885 14.9027C9.51901 14.9321 9.28667 14.8703 9.10404 14.7311L4.92626 11.4745C4.5576 11.1868 4.49791 10.6622 4.79293 10.3028C5.08795 9.94334 5.62598 9.88514 5.99464 10.1728L9.4784 12.8903L14.8006 5.84778C14.9751 5.59244 15.2795 5.45127 15.5928 5.48032C15.9061 5.50936 16.1776 5.70393 16.2997 5.98676C16.4217 6.2696 16.3745 6.59494 16.1767 6.83362Z",
    fill: "#017C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.60de8c37a554e46a4493460cbe9d2791.svg";
export { ForwardRef as ReactComponent };